module.exports = __webpack_public_path__ + "img/adeste.b82c1abd.jpeg";